import axios from "axios";

interface ProspectHistoryEventModel {
  Notes: string;
  Date: string; 
  ProspectId: number;
  ProspectStatusId: number;
  ProspectHistoryEventTypeId: number;
  Consultants: number[];
}

/**
 * Ensures all required fields are present in the payload, with defaults for missing values.
 * @param {ProspectHistoryEventModel} obj - The object to sanitize.
 * @returns {Record<string, any>} - A sanitized object containing all non-optional fields.
 */
const sanitizePayload = (obj: ProspectHistoryEventModel): Record<string, any> => {
  return {
    Notes: obj.Notes ?? "",
    Date: obj.Date ?? new Date().toISOString(), // Defaults to current date and time
    ProspectId: obj.ProspectId ?? 0,
    ProspectStatusId: obj.ProspectStatusId ?? 0,
    ProspectHistoryEventTypeId: obj.ProspectHistoryEventTypeId ?? 0,
    Consultants: obj.Consultants ?? [], // Defaults to an empty list
  };
};

/**
 * Creates a new prospect history event using the backend API.
 * @param {ProspectHistoryEventModel} payload - The event data to send to the API.
 * @returns {Promise<any>} - Resolves with the API response when successful.
 */
const createProspectEvent = async (
  payload: ProspectHistoryEventModel
): Promise<any> => {
  try {
    const sanitizedPayload = sanitizePayload(payload);

    console.log("DEBUG createProspectEvent.ts: Sending sanitized payload to API:", sanitizedPayload);

    const { data } = await axios({
      method: "POST",
      url: `/api/cantrackv3/CreateProspectHistoryEvent`,
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { payload: sanitizedPayload },
    });

    console.log("DEBUG createProspectEvent.ts: Event created successfully:", data);
    return data;
  } catch (error) {
    console.error("DEBUG createProspectEvent.ts: Error creating event:", error);
    throw error;
  }
};

export default createProspectEvent;
